import React from 'react';
import * as R from 'ramda';
import {ModalHeader, ModalBody} from 'reactstrap';
import {useTranslation} from 'react-i18next';
import dompurify from 'dompurify';

import useAPI from '@/hooks/useAPI';
import {srDetail} from '@/b2b/apis';

import {blank, present} from '@/util';

import PolicyStatement from '@/b2b/pages/PolicyStatement';
import {PopError} from '@/b2b/components/Pop';
import styles from '@/b2b/index.module.css';

const ServiceRecrodDetail = ({handleClick, followupId, setContent}) => {
  const {t: tr} = useTranslation('nb');
  const {result, error} = useAPI(srDetail, {args: [followupId]});

  if (present(error)) {
    return <PopError error={String(error)} />;
  }

  const InnerHtml = ({html}) => {
    const cleanup = dompurify.sanitize(html);

    const clickClientParty = event => {
      const current = event.target;
      const partyId = current.getAttribute('data-party-id');
      if (current.tagName === 'IMG' && !blank(partyId)) {
        setContent({component: PolicyStatement, partyId});
      }
    };

    return (
      <div
        className={`${styles.pre_text} ${styles.modal_outline}`}
        role='button'
        dangerouslySetInnerHTML={{__html: cleanup}}
        tabIndex={0}
        onClick={clickClientParty}
        onKeyDown={clickClientParty}
      />
    );
  };

  const closeBtn = (
    <span
      role='button'
      tabIndex={0}
      className={styles.modal_close}
      onClick={handleClick}
      onKeyDown={handleClick}
    >
      &times;
    </span>
  );

  return (
    <>
      <ModalHeader
        toggle={handleClick}
        close={closeBtn}
        className={styles.modal_header}
      >
        {tr('service_record_detail')}
      </ModalHeader>
      <ModalBody>
        <InnerHtml html={R.propOr('', 'data', result)} />
      </ModalBody>
    </>
  );
};

export default ServiceRecrodDetail;
